import { render, staticRenderFns } from "./ProfileTemplate.vue?vue&type=template&id=4259688e"
import script from "./ProfileTemplate.vue?vue&type=script&lang=js"
export * from "./ProfileTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports